import http from '@/services/http';
import { tasksFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const tasks = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, tasksFilters);
    return http.request({
      method: 'get',
      url: '/tasks',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, tasksFilters);
    return http.request({
      method: 'get',
      url: '/tasks/count',
      params: { where },
      ...config,
    });
  },
  // TODO: SMP-23 Add my test
  restart(taskId) {
    return http.request({
      method: 'post',
      url: `/tasks/${taskId}/restart`,
    });
  },
};

export default tasks;
